<template>
    <div id="package-detail-wrapper" class="generic-wrapper">
        <router-link id="all-packages-link" :to="{name: 'packages'}">
            <img src="../assets/images/icons/left-arrow.svg" alt="Regresar">
            Ver todos los paquetes
        </router-link>
        <h1 class="page-title">Nombre del Paquete {{ $route.params.id }}</h1>
        <div class="description">
            <p class="body-text">Disfrute el recorrido bajando los turbulentos y emocionantes
                rápidos de Clase III y IV del Río.
                El rafting por el Río incluye instrucción en el uso de las balsas,
                equipo de seguridad, guía experimentado bilingüe, chalecos y cascos.
                Haremos también una pequeña caminata por el río para familiarizarnos
                con los rápidos flotando algunos de ellos. El Parque Nacional Pico Bonito
                limita por la margen izquierda del Río y podremos apreciar su magnifica
                vegetación y paisajes durante todo el viaje. Durante el trayecto tendremos
                también la oportunidad de saltar de algunas rocas en pozas profundas.
                (Duración de la actividad: 4 hrs.)</p>
            <h3 class="title">Incluye</h3>
            <ul>
                <li>Rafting</li>
                <li>2 tiempos de desayuno</li>
                <li>1 Almuerzo (tomado en la cuenca de Río Cangrejal al al
                    finalizar la actividad)
                </li>
                <li>2 tiempos de cena (platillo a la carta)</li>
            </ul>
            <h3 class="title">Detalles</h3>
            <ul>
                <li>Hora de salida: <strong>8:00 am</strong></li>
                <li>Hora de regreso: <strong>2:00 pm</strong></li>
                <li>Mínimo de personas: <strong>3</strong></li>
            </ul>
            <h3 class="title">Checklist del Cliente</h3>
            <ul>
                <li>Calzado anfibio</li>
                <li>Short, camiseta, y toalla (opcional)</li>
                <li>Gorra (opcional)</li>
                <li>Bloqueador solar y repelente</li>
                <li>Gafas para sol</li>
                <li>Cámara contra agua</li>
            </ul>
            <vue-picture-swipe :items="images" />
            <p class="highlight">Llamanos y Reserva tu paquete
                <a href="tel:+50424405298">+504 2440-5298</a>
            </p>
        </div>
        <img class="promo-img" src="../assets/images/packages/rafting-reduced.jpg" alt="Promo">
    </div>
</template>

<script>
    import VuePictureSwipe from 'vue-picture-swipe';

    export default {
        name: "PackageDetails",
        components: {
            VuePictureSwipe
        },
        data() {
            return {
                images: [
                    {
                        src: require('../assets/images/packages/snorkeling2.jpeg'),
                        thumbnail: 'http://via.placeholder.com/150x150',
                        w: 1200,
                        h: 900,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/packages/snorkeling-arrecife.jpeg'),
                        thumbnail: 'http://via.placeholder.com/150x150',
                        w: 1200,
                        h: 900,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/packages/lake-river.jpg'),
                        thumbnail: 'http://via.placeholder.com/150x150',
                        w: 1200,
                        h: 900,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/packages/rio-zacate.jpg'),
                        thumbnail: 'http://via.placeholder.com/150x150',
                        w: 1200,
                        h: 900,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/packages/boa-rosada.jpeg'),
                        thumbnail: 'http://via.placeholder.com/150x150',
                        w: 1200,
                        h: 900,
                        alt: 'Some Unsplash image'
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    #package-detail-wrapper {
        display: flex;
        flex-direction: column;
    }

    #all-packages-link {
        display: block;
        text-decoration: none;
        color: #643229;
        font-size: 1.2rem;
        margin-top: 15px;
    }

    #all-packages-link:hover {
        text-decoration: underline;
    }

    #all-packages-link img {
        width: 20px;
        vertical-align: middle;
    }

    #package-detail-wrapper .description {
        padding: 0 50px;
        margin-bottom: 50px;
        font-size: 1.1rem;
    }

    #package-detail-wrapper .description .title {
        font-size: 1.3rem;
    }

    #package-detail-wrapper .description .highlight {
        text-align: center;
        color: #4d63bc;
        font-weight: 500;
        font-size: 1.4rem;
    }

    #package-detail-wrapper .promo-img {
        align-self: center;
        object-fit: contain;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        #package-detail-wrapper .description {
            padding: 0;
        }
    }
</style>